import { render } from "./numMove.vue?vue&type=template&id=196e7d14&scoped=true"
import script from "./numMove.vue?vue&type=script&lang=js"
export * from "./numMove.vue?vue&type=script&lang=js"

import "./numMove.vue?vue&type=style&index=0&id=196e7d14&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196e7d14"]])

export default __exports__